export default __webpack_public_path__ + "static/media/Appliances-IconsV2.d4c4ab2b.png";